// September 22 at 9 a.m. Eastern (EDT), evaluated when the form renders.
const ACCOUNTS_RECEIVABLE_LAUNCH = Date.parse('2026-09-22T13:00:00Z')

export const getAccountsReceivableInterestOptions = () =>
  Date.now() >= ACCOUNTS_RECEIVABLE_LAUNCH
    ? [
        {
          label: 'Accounts Receivable',
          value: 'interested_in_accounts_receivable' as const,
        },
      ]
    : []
